<template>

  
    <div id="left-side">
        <div class="mframe"> 
            <div class="total">
                <div class="frame">
                  <p class="titillium-sb" data-value="฿"><i class="titillium-r">{{ text.amountToPaid }}</i>  {{ total.split('.')[0] }}<font>.{{ total.split('.')[1] }}</font></p>
                  <div class="details">
                      <div class="paid">
                        <label class="titillium-r">{{ text.paid }}</label>
                        <p class="titillium-sb">{{ paid_Decimal }}</p>
                      </div>
                      <div class="balance">
                        <label class="titillium-r">{{ text.outstanding }}</label>
                        <p class="titillium-sb">{{ outstanding_Decimal }}</p>
                      </div>
                  </div>
                </div>
            </div>
 
            <div class="info">
              <div v-if="page == 'paymentSuccess' && parseFloat(outstanding) == 0" class="text-center">
                <a class="btn titillium-sm" @click="downloadReceipt" style="padding-right: 46px;overflow: hidden;">{{ text.downloadReceipt }}</a>
              </div>

              <div v-if="!paycomplete && parseFloat(outstanding) > 0"  class="remark titillium-r">{{ text.payInDate }}</div>
              <div v-if="!paycomplete && parseFloat(outstanding) > 0"  class="date-time">
                <span>
                    <p class="date titillium-sb">{{ expireDateTime[0] }}</p>
                    <p class="time titillium-sb">{{ expireDateTime[1] }}</p>
                </span>
              </div>
              <div class="id-name">
                <div class="name">
                    <label class="titillium-r">{{ text.name }}</label>
                    <p class="titillium-sb">{{ custname }}</p>
                </div>
                <div class="id">
                    <label class="titillium-r">{{ text.hn }}</label>
                    <p class="titillium-sb">{{ ref1 }}</p>
                </div>
              </div>  
          </div> 

          <div class="line"></div>

          <div class="list" v-if="billPayment.length"> 
            <figure> 
                <div class="id-name"> 
                    <div class="name" v-for="bp in billPayment" :key="bp.id">
                      <label class="titillium-r" style="font-size: 20px;">{{ bp.paymentdetail }}</label>
                      <p class="titillium-sb" style="font-size: 20px;">{{ toDigit(bp.paid) }}</p>
                    </div> 
                </div>  
            </figure>
          </div>

        </div>
    </div>

 
</template>

<script>
export default {
  props: {'page':String},
  data() {
    return { 
      summary: {
        amount : 0,
        discount : 0,
        price : 0,
      },
    }
  },
  created(){
  },
  methods: { 
    toDigit(num) { 
        return this.twoDecimal(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }, 
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },
    downloadReceipt() {
        window.location.href = this.linkurl;
    },
  },
  computed: { 
    linkurl() {
        if (this.paid) {
            return `/billRecieve/?linkcode=${this.$route.query.linkcode}`;
        }
        else {
            return `/paymentMethods/?linkcode=${this.$route.query.linkcode}`;
        }
    },
    text() {
      let obj = {}
      if (this.$store.state.language == 'TH') {
        obj = {
          printReceipt: '**ท่านสามารถกดปุ่มเพื่อแสดงใบเสร็จรับเงิน', 
          downloadReceipt: 'ดาวน์โหลดใบเสร็จ', 
          payment_status: 'ชำระแล้ว',  
          closed:'ปิด',
          amountToPaid: 'ยอดรวม',
          payInDate: 'กรุณาชำระเงินภายใน',
          name: 'ชื่อ-นามสกุล :',
          hn: 'เลขประจำตัวผู้ป่วย :', 
          payDetail: 'แสดงรายละเอียดค่ารักษาพยาบาล', 
          payDetailNotFount: 'ไม่พบรายละเอียดค่ารักษาพยาบาล', 
          payDetailList: 'รายการ', 
          payDetailAmount: 'จำนวนเงิน', 
          payDetailDiscount: 'ส่วนลด', 
          payDetailNet: 'ยอดสุทธิ', 
          paymentType: 'เลือกวิธีการชำระเงิน', 
          nextButton: 'ดำเนินการต่อ',
          linkExp: 'ลิงค์ชำระเงินนี้หมดอายุแล้ว',
          expireDateTime: this.$store.state.expireDateTimeTh,
          summary: 'รวม',
          titleDetail: 'ชำระเงินสำเร็จ',
          paid: 'ชำระแล้ว',
          total: 'ยอดรวม',
          outstanding: 'ชำระเพิ่ม',
          expireDate: 'กรุณาชำระเงินให้ครบภายใน วันที่',
          download: 'ดาวน์โหลด',
          attention:'กรุณาเลือกวิธีการชำระเงิน เพื่อดำเนินการชำระเงินให้สมบูรณ์',
        }
      } else {
        obj = {
          printReceipt: '**You can press the button to show the receipt.', 
          downloadReceipt: 'Download receipt',
          payment_status: 'Paid', 
          closed:'close',
          amountToPaid: 'Total',
          payInDate: ' Please pay in full before ',
          name: 'Name :',
          hn: 'HN :', 
          payDetail: 'Show details of medical expenses', 
          payDetailNotFount: 'Not Found details of medical expenses', 
          payDetailList: 'List', 
          payDetailAmount: 'Amount', 
          payDetailDiscount: 'Discount', 
          payDetailNet: 'Net balance', 
          paymentType: 'Payment Type', 
          nextButton: 'Next',
          linkExp: 'This link expire.',
          expireDateTime: this.$store.state.expireDateTimeEn,
          summary: 'Total',
          titleDetail: 'Payment Success',
          paid: 'Paid',
          total: 'Total',
          outstanding: 'Balance',
          expireDate: 'Please pay in full before ',
          download: 'Download',
          attention: 'Please specific payment type to complete this payment',
        }
      }
      return obj
    },
    billPayment() {
      return this.$store.state.billPayment ? this.$store.state.billPayment : []
    },
    files() {
      if (!this.$store.state.files) return []
      return this.$store.state.files
    },
    outstanding_Decimal() { 
      return this.twoDecimal(this.$store.state.outstanding)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }, 
    outstanding() { 
      return  this.$store.state.outstanding
    }, 
    splited() {
      return this.$store.getters.splited
    }, 
    expireDateTime() {
      var x = ''
      if (this.$store.state.language == 'TH') {
         x = this.$store.state.expireDateTimeTh.split('เวลา')
      }else{
         x = this.$store.state.expireDateTimeEn.split('-')
      }
      return x
    }, 
    paycomplete() {
      return this.$store.state.paycomplete
    },
    titleDetail() {
      return this.$options.filters.dbTextDisplay('Detail')
    }, 
    name() {
        return this.$store.state.name
    },  
    custname() {
        return this.$store.state.name;
    },
    total() {  
        return this.twoDecimal(this.$store.state.total)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }, 

    ref1() {
      return this.$store.state.ref1
    }, 
    invoice() {
      this.summary = {
        amount : 0,
        discount : 0,
        price : 0,
      }
      var inv = Object.values(this.$store.state.invoicedesc).map((res) => {
        if (this.$store.state.language == 'EN') {
          res.description = res.description_en
        }else{
          res.description = res.description_th
        }
        this.summary.amount += parseFloat(res.amount)
        this.summary.discount += parseFloat(res.discount)
        this.summary.price += parseFloat(res.price)
        return res
      })   
      return inv
    },
    
    titleName() {
      return this.$options.filters.dbTextDisplay('CustName')
    },

    titleRef1() {
      return this.$options.filters.dbTextDisplay('Ref1')
    }, 
    docNo() {
      return this.$store.state.docNo
    },
    docDateTime() {
      if (this.$store.state.language == 'EN') {
        return this.$store.state.docDateTimeEn
      } else {
        return this.$store.state.docDateTimeTh
      }
    },  
    paid_Decimal() {
      return this.twoDecimal(this.$store.state.paid)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }, 
    paid() {
      return this.$store.state.paid
    }, 
  }, 
}
</script>